import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Typography } from "@mui/material";
import { type FC, useState } from "react";

import type { IFAQItem } from "~/types/FAQ";

import * as Styled from "./FAQAccordion.styles";

interface IFAQAccordionProps {
  items: IFAQItem[];
}

export const FAQAccordion: FC<IFAQAccordionProps> = ({ items }) => {
  const [expandedIndex, setExpandedIndex] = useState<number | false>(
    items.length ? 0 : false
  );

  if (!items.length) {
    return null;
  }

  return (
    <Styled.Root>
      {items.map(({ question, answer }, index) => {
        const isExpanded = expandedIndex === index;
        const summaryId = `faq-question-${index}`;
        const detailsId = `faq-answer-${index}`;

        return (
          <Styled.Item
            key={`${question}-${index}`}
            expanded={isExpanded}
            onChange={() =>
              setExpandedIndex((currentIndex) =>
                currentIndex === index ? false : index
              )
            }
            disableGutters
          >
            <Styled.Summary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={detailsId}
              id={summaryId}
            >
              <Typography
                component="h3"
                variant="subtitle1"
                sx={{
                  fontWeight: 700,
                  fontSize: "1rem"
                }}>
                {question}
              </Typography>
            </Styled.Summary>
            <Styled.Details id={detailsId} aria-labelledby={summaryId}>
              <Typography component="p" variant="caption" sx={{
                color: "text.secondary"
              }}>
                {answer}
              </Typography>
            </Styled.Details>
          </Styled.Item>
        );
      })}
    </Styled.Root>
  );
};
